"use strict";
/*
 * Created on 09 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceTerminationUpload_1 = require("../../../price-termination/model/PriceTerminationUpload");
/**
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationUpload =
/*#__PURE__*/
function (_PriceTerminationUplo) {
  _inherits(SiteReleaseTerminationUpload, _PriceTerminationUplo);

  function SiteReleaseTerminationUpload() {
    _classCallCheck(this, SiteReleaseTerminationUpload);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationUpload).apply(this, arguments));
  }

  return SiteReleaseTerminationUpload;
}(PriceTerminationUpload_1.PriceTerminationUpload);

exports.SiteReleaseTerminationUpload = SiteReleaseTerminationUpload;